import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon/Icon'

import './components.css'

const Footer = () => {
  return (
    <div className='footer_container'>
      <div className="nav_item-footer">
        <div className="footer_link">
          <Link to='/' className='logo'><img src={Icon.logo} alt="Logo" /></Link>
          <Link to='/'>HOME</Link>
          <Link to='/about'>ABOUT</Link>
          <Link to='/team'>TEAM</Link>
          <Link to='/services'>SERVICES</Link>
          <Link to='/how-its-work'>HOW IT WORKS</Link>
          <Link to='/blog'>BLOG</Link>
        </div>
        <div className="footer_soc-link">
          <p>Kyiv, Ukraine</p>
          <Link to='tel:+48516069503' target='blank'>Tel: +48516069503</Link>
          <Link to='tel:+380952711631' target='blank'>Tel: +380952711631</Link>
          <Link target='blank' to='https://www.linkedin.com/in/alexandra-misiats-62b88030?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'>LinkedIn</Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;